<template>
  <div>
    <dx-grid url="CampCoupons" :columns="columns" :title="title"></dx-grid>
  </div>
</template>

<script>
export default {
  data: () => ({
    title: "Camp Coupons",
    columns: [
      {
        label: "Account ID",
        field: "accountID",
        template: "link-action-cell-template",
        linkAction: null,
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Name",
        field: "name",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Hebrew Name",
        field: "hebrewName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Coupon Date",
        field: "couponDate",
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        sortOrder: "desc",
        sortIndex: 0,
      },
      {
        label: "Redeemed At",
        field: "redeemedAt",
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Redeemed By",
        field: "redeemedBy",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Amount",
        field: "amount",
        type: "number",
        format: { type: "currency", precision: 2 },
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Amount Redeemed",
        field: "amountRedeemed",
        type: "number",
        format: { type: "currency", precision: 2 },
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Emailed At",
        field: "emailedAt",
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Downloaded At",
        field: "downloadedAt",
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Note",
        field: "note",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Created By",
        field: "createdBy",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Email Address",
        field: "emailAddress",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Address 1",
        field: "address1",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Home Phone",
        field: "homePhone",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Cell Phone",
        field: "cellPhone",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  created() {
    const accountIdColumn = this.columns.find((c) => c.field == "accountID");
    if (!accountIdColumn) return;

    accountIdColumn.linkAction = (row) => {
      this.openAccountCoupons(row);
    };
  },
  methods: {
    openAccountCoupons(row) {
      if (!row || !row.accountID) return;

      this.$router.push({
        name: "Account View",
        params: {
          id: row.accountID,
        },
        query: {
          goToCouponsSection: "true",
        },
      });
    },
  },
};
</script>
